import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionDto } from '../models/session.model';

@Injectable({ providedIn: 'root' })
export class SessionProvider {
  constructor(private http: HttpClient) {}

  getSession(): Observable<SessionDto> {
    const url = `/api/auth/session`;
    return this.http.get<SessionDto>(url);
  }

  signIn(email: string, password: string, rememberMe: boolean): Observable<SessionDto> {
    const url = `/api/auth/sign-in`;
    return this.http.post<SessionDto>(url, { email, password, rememberMe });
  }

  signOut(): Observable<void> {
    const url = `/api/auth/sign-out`;
    return this.http.post<void>(url, null);
  }
}
